import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';

import colorContrast from 'color-contrast';
import logo_hr from '../../../../assets/images/brand/assista_horizontal-punchout.svg';
import logo from '../../../../assets/images/brand/assista.svg';

export const Navbar = ({ user, deceasedUser, deathDeclaration, partnerColor, logoContent}) => {
    const router = useSelector(state => state.router);
    const onBoardingStep = deathDeclaration.onBoardingStep;

    const colorCustom = (!R.isNil(partnerColor) && partnerColor !== '') ? (colorContrast('#fff', partnerColor) >= 2.5 ? " text-white navbar-dark" : " navbar-light") : " text-white navbar-dark";
    const logo = R.isNil(logoContent) ? logo_hr : logoContent;

    const pathParts = router.location.pathname.split("/");
    let currentUserId = undefined;
    if (pathParts.length >= 3) {
        if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathParts[2])) {
            currentUserId = pathParts[2];
        }
    }
    return (
        <header className={"aside onboard-aside navbar navbar-expand-lg py-4 pt-lg-5" + colorCustom}>
            <div className="container-fluid px-gutter justify-content-between align-item-center d-md-flex flex-lg-column h-100">
                <Link className="navbar-brand mr-lg-auto" to={`/facilita`}>
                    <img className={"img-fluid" + (logoContent ? " rounded-sm img-avatar" : "")} src={logo} alt={"Assist@" + (logoContent ? " Partner" : "")} height="80" width="212" onError={(ev) => ev.target.src = logo_hr} />
                    <h1 className="sr-only visually-hidden">Assist@: Menu</h1>
                </Link>
                <div className="d-flex align-items-center">
                    <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div className={"collapse navbar-collapse flex-column mt-3 mt-lg-0" + ((router.location.pathname === `/facilita/${deceasedUser.id}/declarer/step1`) ? ' ' : ' pb-lg-0')} id="navbar-collapse">
                    <nav className="card w-100 rounded-cta bg-stage flex-grow-0 mb-4 h-100 border-0">
                        <h1 className="sr-only visually-hidden">Menu: navigation</h1>

                        <div className="nav-item text-center">
                            <div className="h3 font-weight-bold lh-1 mt-3">{!R.isNil(user) ? `${user.firstName} ${user.lastName}` : 'The Undertaker'}</div>
                            <ul className="nav navbar-inline align-items-center justify-content-around container-paper mx-auto">
                                <NavLink className={"nav-item inline-item o-80 o-100--hover"} activeClassName="o-100 active" to="/facilita/settings">
                                    <div className="nav-link p-2 mb-0 lh-1">
                                        <i className="eva eva-settings-2-outline h3 lh-1 my-auto icon-default"></i>
                                    </div>
                                </NavLink>
                                {/* <Link className={"nav-item inline-item o-80 o-100--hover"} to="#">
                                <div className="nav-link p-2 mb-0 lh-1">
                                    <i className="eva eva-bell-outline h3 lh-1 my-auto icon-default"></i>
                                </div>
                            </Link> */}
                                <div role="button" className={"nav-item inline-item o-80 o-100--hover"} onClick={() => {
                                    localStorage.removeItem("access_token");
                                    setTimeout(() => {
                                        window.location = '/index';
                                    }, 100);
                                }}>
                                    <div className="nav-link p-2 mb-0 lh-1">
                                        <i className="eva eva-power-outline h3 lh-1 my-auto icon-default"></i>
                                    </div>
                                </div>
                            </ul>
                        </div>


                        <div className="nav-item show">
                            <div className="card bg-faded text-body shadow text-center">
                                <div className="card-header pb-0">
                                    <div className="h6 o-60 font-weight-bold lh-1 mb-1">Dossier de</div>
                                    <div className="h4 text-uppercase font-weight-bold lh-1 mb-0">{deceasedUser.firstName} {deceasedUser.lastName}</div>
                                </div>
                                <div className="card-footer">
                                    <div className="h6 o-60 font-weight-bold lh-1 mb-1">Numéro de processus</div>
                                    <div className="h4 font-weight-bold lh-1 mb-0">{!R.isNil(deceasedUser) && deceasedUser.processNumber !== '' ?  deceasedUser.processNumber : 'N/D'}</div>
                                </div>
                            </div>
                            <ul className="card-body navbar-nav">
                                <NavLink className={"nav-item" + ((onBoardingStep > 1) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/declarer/step1`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Déclarer le décès</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 2) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/declarer/step2`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Validation</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 3) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/declarer/step3`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">ALLOCATIONS ET AIDES</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 4) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/declarer/step4`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">REVERSION</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink>
                            </ul>
                        </div>
                        <button type="button" className={"btn btn-light text-primary mx-auto border-none px-3 rounded mb-3 ls-n1 fs-3" + (router.location.pathname === `/facilita/settings` ? " mt-3" : " mt-auto")} onClick={(e) => {
                                    e.preventDefault();
                                    window.location = `/funecap/dossiers/${currentUserId}`;
                                }}>Retour au dossier</button>
                    </nav>
                    {/* <Link className="btn btn-light btn-block px-2 mt-auto text-body" to="/facilita">Annuler</Link> */}
                </div>
            </div>
        </header>
    )
}